export const State = {
  Loading: 'Loading',
  Success: 'Success',
  Warning: 'Warning',
  Error: 'Error'
} as const;

export type State = (typeof State)[keyof typeof State];
